import { useParams, Link } from 'react-router-dom';
import usePage from '../hooks/usePage';
import { transformProductDetails } from '../utils/dataTransformer';
import './ProductDetailsPage.css';

const ProductDetailsPage = () => {
    const { slug } = useParams();
    const { page, loading, error } = usePage(slug);

    const product = page?.acf ? transformProductDetails(page.acf) : null;

    if (loading) {
        return (
            <div className="app-loading">
                <div className="app-loading__spinner" />
            </div>
        );
    }

    if (error || !product) {
        return (
            <section>
            <header className="product-header">
                <div className="header-container">
                    <nav className="breadcrumb" aria-label="Breadcrumb">
                        <Link to="/" className="breadcrumb-link">Home</Link>
                        <span className="breadcrumb-sep">/</span>
                        <span className="breadcrumb-current">Product</span>
                    </nav>
                </div>
            </header>
                <main className="page-main">
                    <div className="container">
                        <div className="product-detail-error">
                            <h2 className="product-detail-error-title">Product not found</h2>
                            <p className="product-detail-error-message">
                                {error || 'We couldn\'t find details for this product.'}
                            </p>
                            <Link to="/" className="btn btn-primary">Go Home</Link>
                        </div>
                    </div>
                </main>
            </section>

        );
    }

    return (
        <section>
        <header className="product-header">
            <div className="header-container">
                <nav className="breadcrumb" aria-label="Breadcrumb">
                    <Link to="/" className="breadcrumb-link">Home</Link>
                    <span className="breadcrumb-sep">/</span>
                    <span className="breadcrumb-current">{product.sector}</span>
                </nav>
                <h2 className="service-hero__title">{product.name}</h2>
            </div>
        </header>
            <main className="page-main">
                <section className="product-detail-hero container">
                    <div className="product-detail-hero-text">
                        <p className="product-detail-desc">{product.description}</p>
                    </div>
                    {product.imageUrl ? (
                        <div className="product-detail-hero-image">
                            <img
                                className="product-detail-hero-img"
                                src={product.imageUrl}
                                alt={product.name}
                            />
                        </div>
                    ) : (
                        <div className="product-detail-hero-image">
                            <div className="product-detail-image-glow" />
                        </div>
                    )}
                </section>

                {product.sections.map((section, sIdx) => (
                    <section className="product-detail-section container" key={sIdx}>
                        <div className="product-detail-section-header">
                            <div className="product-detail-section-line" />
                            <span className="product-detail-section-label">
                                {section.name.toUpperCase()}
                            </span>
                        </div>
                        <div className="product-detail-features-grid">
                            {section.features.map((feature, fIdx) => (
                                <div className="product-detail-feature-card" key={fIdx}>
                                    <div className="product-detail-feature-index">
                                        {String(fIdx + 1).padStart(2, '0')}
                                    </div>
                                    <h3 className="product-detail-feature-title">{feature.title}</h3>
                                    <p className="product-detail-feature-desc">{feature.desc}</p>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </main>
        </section>
    );
};

export default ProductDetailsPage;
